import './Stats.css';
const STATS = [
  { num: '10B+', label: 'Mutlu Müşteri' },
  { num: '15+',  label: 'Yıllık Tecrübe' },
  { num: '24/7', label: 'Acil Servis' },
  { num: '100%', label: 'Garanti' },
];
function Stats() {
  return (
    <section className="stats">
      <div className="stats__row">
        {STATS.map(s => (
          <div key={s.label} className="stats__item">
            <div className="stats__num">{s.num}</div>
            <div className="stats__label">{s.label}</div>
          </div>
        ))}
      </div>
    </section>
  );
}
export default Stats;
